import React from 'react';
import { getDirectionText, DirectionArrowSVG } from '../../../utils/helpers';

const SwellWaveDirectionRow = ({dayData, units, data}) => {

    return (
        <tr className="hover:bg-custom-darker/50 transition-colors">
            <td className="pl-2 py-1 text-xs text-custom-light-grey ">
                <div className="inline-flex items-center gap-2 font-medium">
                    <div>
                        <span className="block sm:hidden">Swell&nbsp;D</span>
                        <span className="hidden sm:block">Swell Direction</span>
                    </div>
                </div>
            </td>
            {dayData.map(({ index }) => {
                const swellDirection = data?.[index];
                return (
                    <td key={index} className="py-1 text-center">
                        {units ? (
                            <div className="inline-block min-w-[30px] text-center">
                                <div className="flex flex-col items-center gap-1">
                                    <DirectionArrowSVG degrees={swellDirection} size={24} color="#13a4ec" />
                                    {/* <span className="text-xs text-custom-light-grey font-medium">
                                        {getDirectionText(swellDirection)}
                                    </span> */}
                                </div>
                            </div>
                        ) : null}
                    </td>
                );
            })}
        </tr>
    )
}

export default SwellWaveDirectionRow;